<template>
	<c-dialog ref="dialog" width="800" mode="slide" @resolve="editHandle">
		<c-form ref="processRouteProductForm" unit-width="100%">
            <c-form-item :label="false" name="product_list">
                <m-operate border>
                    <c-button color="main" prepend-icon="tf-add" @click="globalDialog('productSelector', {props: {initParam: {product_sources:[1]}}}, productSelectorHandle)">添加产品</c-button>
                </m-operate>
                <c-table ref="process_table" :data="productList" border :paging="false">
					<!--产品来源-->
					<c-table-column label="产品来源" width="80">
					    <template #default="{data}">
					        <c-state dict="productSourceName" :value="data.product_source"></c-state>
					    </template>
					</c-table-column>
                    <!--产品类型-->
                    <c-table-column label="产品类型" width="80">
                        <template #default="{data}">
                            <c-state dict="productTypeName" :value="data.product_type"></c-state>
                        </template>
                    </c-table-column>
                    <c-table-column label="产品编号" width="120">
                        <template #default="{data}">
                            <span>{{data.product_code}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="产品名称" width="180">
                        <template #default="{data}">
                            <span>{{data.product_name}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="产品规格" width="100">
                        <template #default="{data}">
                            <span v-if="data.product_spec">{{data.product_spec}}</span>
                            <span v-else></span>
                        </template>
                    </c-table-column>

                    <c-table-column type="button" label="操作" width="80">
                        <template #default="row">
                            <c-table-button v-if="auth('b_processroute_product_edit')" v-lock="lock('b_processroute_product_edit')" icon="tf-trash" color="red" @click="rowProduct(row)">删除</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
            </c-form-item>
        </c-form>
	</c-dialog>
</template>

<script>
export default {
	name: 'process_route_product_edit',
	data() {
		return {
			route_id:0,
            productList:[]
		}
	},
	methods: {
		/************打开新增、编辑弹窗**************/
		open(data) {
            this.productList = [];
            this.route_id = data.id;
            this.getDetail();
			this.$refs.dialog.open({
				title: '【'+data.route_name+'】关联产品'
			});
		},

		/*******搜索工艺路线详情*******************/
		getDetail() {
			this.request({
				url:'/process/route/detail',
				data: {
					id: this.route_id
				},
				loading: true,
				success: data => {
					if (data && data.product_list && data.product_list.length > 0){
                        this.productList = data.product_list;
					}
                }
			});
		},
        /**
         * 删除商品
         */
        rowProduct(row){
            this.productList.splice(row.index, 1);
        },

        /******选择产品响应方法*********/
        productSelectorHandle(data) {
            //判断是否已存在于表格之中，已存在则不允许添加
            for (var i = 0; i < data.length; i++) {
                var newProduct = data[i];
                var existObj = this.productList.find(function (obj) {
                    return obj.product_id == newProduct.id
                });
                if (existObj){
                    this.$message({
                        type:'warn',
                        message:'产品【'+existObj.product_code+' | '+existObj.product_name+'】已存在，请勿重复添加',
                    });
                    return;
                }
            }
            //处理数据
            var productList = data.map(item => {
                item.product_id = item.id;
                return item;
            });
            productList.map(item =>{
                this.productList.push(item);
            })
        },

		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
            var product_ids = [];
            if (this.productList && this.productList.length > 0){
                product_ids  = this.productList.map(item => {
                    return item.id
                });
            }
            this.request({
                url: '/process/route/edit/product',
                data: {
                    id:this.route_id,
                    product_ids:product_ids
                },
                success:data => {
                    next();
                    this.$message({
                        message:'编辑工艺路线关联商品成功',
                    });
                    //刷新页面
                    this.$emit('resolve');
                }
            });
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>